const CUSTOMER_MAP: Record<string, string> = {
	COMPASS: "Compass Group",
	MIAMIDADE: "Miami-Dade County",
	NYCHH: "NYC Health + Hospitals",
	BANKOFAMERICA: "Bank of America",
	PRUDENTIAL: "Prudential",
	QUAD: "N/A",
};

const formatCustomerName = (
	name: string | null | undefined,
	hostName: string
) => {
	// if name is blank/dash/N/A, or we always want to override for this host:
	if (!name || name === "—" || name === "N/A") {
		return CUSTOMER_MAP[hostName] ?? name ?? "";
	}
	// otherwise return the real name
	return name;
};

export default formatCustomerName;
